import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function getVisitorId() {
  let id = localStorage.getItem("monaga_vid");
  if (!id) {
    id = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("monaga_vid", id);
  }
  return id;
}

export default function Tracker() {
  const loc = useLocation();
  useEffect(() => {
    try {
      fetch(`${BACKEND}/api/analytics/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path: loc.pathname, visitor_id: getVisitorId(), referrer: document.referrer || "" }),
        keepalive: true,
      }).catch(() => {});
    } catch { /* noop */ }
  }, [loc.pathname]);
  return null;
}
